import { render, staticRenderFns } from "./CampaignGoalName.vue?vue&type=template&id=6ec42a00&scoped=true&"
import script from "./CampaignGoalName.vue?vue&type=script&lang=js&"
export * from "./CampaignGoalName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec42a00",
  null
  
)

export default component.exports